import React, { useState, useEffect } from 'react';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { Link } from 'react-router-dom';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { Create } from './Components/Create';
import { View } from './Components/View';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import { CalendarOutlined, FileTextOutlined, UserOutlined } from '@ant-design/icons';
import './Schedule.css';

export function ClassSchedule(props) {
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const [currentDocument, setCurrentDocument] = useState(null);
   const [level, setLevel] = useState(null);
   const [section, setSection] = useState(null);

   useEffect(() => {
      Utils.verifyJwt();

   }, []);

   const handleFinishUploading = (document) => {
      setCurrentDocument(document);
   }

   const handleChangeSearchCriteria = (level, section) => {
      setLevel(level);
      setSection(section);
   }

   return (
      <>
         <div className="dashboard-area-all schedule-page">
            <div className="dashboard-item schedule-shell">
               <div className="schedule-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'schedule', node: 'Schedule' },
                        { key: 'class-schedule', node: 'Class Schedule' },
                     ]}
                  />
               </div>
               <section className="schedule-overview">
                  <div>
                     <span className="schedule-kicker">Schedule</span>
                     <h1>Class Schedule</h1>
                     <p>Search, upload, and review class schedule files for each level and section.</p>
                     <div className="schedule-meta">
                        <span><CalendarOutlined /> Class timetable</span>
                        <span><UserOutlined /> {user_role}</span>
                     </div>
                  </div>
                  {(['Super Admin', 'Admin', 'Teacher'].includes(user_role)) &&
                     <div className="schedule-actions">
                        <Create
                           type='class'
                           level={level}
                           button_label='Class Schedule'
                           section={section}
                           onFinishCreateCallback={handleFinishUploading}
                        />
                     </div>
                  }
               </section>

               <section className="schedule-panel">
                  <div className="schedule-panel-header">
                     <div>
                        <span className="schedule-kicker">Document</span>
                        <h2>Class Schedule File</h2>
                     </div>
                     <div className="schedule-meta" style={{ marginTop: 0 }}>
                        <span><FileTextOutlined /> {currentDocument ? 'Available' : 'Search by class'}</span>
                     </div>
                  </div>
                  <View
                     type='class'
                     uploader={user_id}
                     document={currentDocument}
                     onChangeSearchCriteria={handleChangeSearchCriteria}
                     showsearchtools={true}
                     emptydescription='Class schedule not available.'
                  />
               </section>

            </div>
         </div>

         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}
